/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Tag } from '@ui/components';

export const DefaultTagExample = () => <Tag>Default</Tag>;

export const ColorsTagExample = () => (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 8 }}>
        <Tag color="success">Success</Tag>
        <Tag color="processing">Processing</Tag>
        <Tag color="warning">Warning</Tag>
        <Tag color="error">Error</Tag>
        <Tag color="blue">Blue</Tag>
    </span>
);

export const ClosableTagExample = () => <Tag closable>Closable</Tag>;

export const LongTextTagExample = () => (
    <Tag style={{ maxWidth: 220, whiteSpace: 'normal' }}>
        A longer tag label that shows how the tag handles extended content
    </Tag>
);
